<template>
    <main role="main">
        <article :data-details="null" class="layout-contents-container">
            <div class="layout-page-title">
                <button class="buttons-icon" data-icon="back" data-type="line" type="button" @click="goBack()">Back
                </button>
                <h1 class="page-title">
                    <template>
                        {{ $t('MENU.POLICY_TEMPLATE') }}<!--Policy Template-->
                    </template>
                </h1>
            </div>
            <!-- SUB TITLE -->
            <div class="po-subtitle">
                <div class="policy-item">
                    <div class="badge" v-show="!pending">
                        <span class="icon-tag" v-bind:data-type="bUserSetting ? 'policy-custom' : 'policy-system'">
                        {{ $t(bUserSetting ? 'TYPE.CUSTOM' : 'TYPE.BEST_PRACTICE') }}
                        </span>
                    </div>
                    <h2 :title="plcy.userDefiYn === constants.PARAM.SELECT.N ? plcy[$i18n.locale+'Title'] : plcy.titl"
                        class="name">
                        <span
                            class="ellipsis">{{ plcy.userDefiYn === constants.PARAM.SELECT.N ? plcy[$i18n.locale + 'Title'] : plcy.titl }}</span>
                        <!-- 정책 이름 수정 -->
                        <fieldset v-if="fEdit.titl === true" class="edit-layer">
                            <legend>{{ $t('POLICY.LABEL.CHANGE_POLICY_NAME') }}</legend>

                            <div class="hstack">
                                <input v-model="plcy.titl" :data-invalid="invalidPolicyTitle || duplicatedPolicyTitle ? true : null" class="text-field" data-size="s"
                                       style="width: 550px;"
                                       type="text"
                                       @focusout="isInvalidPolicyTitle()"
                                       @input="plcy.titl = $event.target.value; isInvalidPolicyTitle()">
                                <div v-if="invalidPolicyTitle" class="invalid-icon">
                                    <p class="invalid-message">{{ $t('POLICY.INVALID.TITLE') }}<!--정책 이름을 입력해주세요.--></p>
                                </div>
                                <div v-if="duplicatedPolicyTitle" class="invalid-icon">
                                    <p class="invalid-message">{{ $t('POLICY.INVALID.DUPLICATE') }}
                                        <!--이미 사용 중인 이름입니다.--></p>
                                </div>
                                <button :title="$t('COMMON.BUTTON.CAMEL.OK')" class="buttons-icon" data-icon="confirm" data-size="s"
                                        data-type="line" type="button"
                                        @click="updtPlcy('titl')"><!--확인--></button>
                                <button :title="$t('COMMON.BUTTON.CAMEL.CANCEL')" class="buttons-icon" data-icon="refresh" data-size="s"
                                        data-type="line" type="button"
                                        @click="cancelUpdtPlcy('titl')"><!--취소--></button>
                            </div>
                        </fieldset>
                        <button v-if="bUserSetting && (getMenuAuth === constants.AUTH_TYPE.EDIT)" class="buttons-icon"
                                data-icon="edit" data-size="s" data-type="ghost" type="button"
                                @click="changeEditStatus('titl', true)"><!--수정--></button>
                    </h2>
                    <span :title="plcy.userDefiYn === constants.PARAM.SELECT.N ? plcy[$i18n.locale+'Desc'] : plcy.desc"
                          class="desc">
                        <span v-if="plcy.desc != null && plcy.desc != ''"
                              class="ellipsis">{{ plcy.userDefiYn === constants.PARAM.SELECT.N ? plcy[$i18n.locale + 'Desc'] : plcy.desc }}</span>
                        <span v-else class="ellipsis">{{ $t('POLICY.LABEL.DESC_DESC') }}</span>
                        <!-- 정책 설명 수정 -->
                        <fieldset v-if="fEdit.desc  === true" class="edit-layer">
                            <legend>{{ $t('POLICY.LABEL.CHANGE_POLICY_DESC') }}</legend>

                            <div class="hstack">
                                <input v-model="plcy.desc" class="text-field" data-size="s" style="width: 760px;"
                                       type="text">
                                <button :title="$t('COMMON.BUTTON.CAMEL.OK')" class="buttons-icon" data-icon="confirm" data-size="s"
                                        data-type="line" type="button"
                                        @click="updtPlcy('desc')"><!--확인--></button>
                                <button :title="$t('COMMON.BUTTON.CAMEL.CANCEL')" class="buttons-icon" data-icon="refresh" data-size="s"
                                        data-type="line" type="button"
                                        @click="cancelUpdtPlcy('desc')"><!--취소--></button>
                            </div>
                        </fieldset>
                        <button v-if="bUserSetting && (getMenuAuth === constants.AUTH_TYPE.EDIT)" class="buttons-icon edit-btn"
                                data-icon="edit" data-size="s" data-type="ghost" type="button"
                                @click="changeEditStatus('desc', true)"><!--수정--></button>
                    </span>
                </div>
                <div class="actions">
                    <button v-if="getMenuAuth === constants.AUTH_TYPE.EDIT"
                        class="buttons"
                        data-type="key"
                        @click="openAddSchePopup(plcy)">
                            {{ $t('POLICY.BUTTON.ADD_ASSESSMENT_ITEM') }}<!--추가-->
                    </button>
                    <button class="buttons-icon"
                        data-icon="more" data-tooltip-content="#tooltip-actions01" data-trigger="management"
                        data-type="line" type="button">{{ $t('LABEL.MANAGE') }}
                    </button>
                    <!-- 관리 버튼 툴팁 메뉴 -->
                    <div class="tooltip_templates">
                        <div id="tooltip-actions01">
                            <ul class="list-actions">
                                <li v-if="getMenuAuth === constants.AUTH_TYPE.EDIT">
                                    <button class="btn" data-trigger="" type="button" @click="replicatePolicy()">
                                        {{ $t('COMMON.BUTTON.CAMEL.COPY') }}<!--복사--></button>
                                </li>
                                <li v-if="bUserSetting && (getMenuAuth === constants.AUTH_TYPE.EDIT)">
                                    <button class="btn" data-trigger="" type="button" @click="openDeleteModal">
                                        {{ $t('COMMON.BUTTON.CAMEL.DELETE') }}<!--삭제--></button>
                                </li>
                                <li>
                                    <button class="btn" data-trigger="" type="button" @click="goToHistory(plcy)">
                                        {{ $t('POLICY.BUTTON.VIEW_HISTORY') }}<!--히스토리 보기--></button>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>


            <!-- Policy 복사일 때 -->
            <div class="layout-contents" data-not-covered>
                <div class="left-view">

                    <!-- 기본 정보 -->
                    <div class="box-container" data-size-to-fit>
                        <table class="tbl-basic-info">
                            <caption>{{ $t('POLICY.LABEL.BASIC_INFORMATION') }}</caption>
                            <tbody>
                            <tr>
                                <th scope="row">
                                    {{ $t('LABEL.EVAL_STAT') }}<!--검사 상태-->
                                </th>
                                <td>
                                    <span v-if="plcy.execDt != null && plcy.cmplStat === 'P'"
                                          class="icon-tag" data-type="success">{{ $t('POLICY.EVAL_STAT.PASS') }}
                                        <!--패스--></span>
                                    <span
                                        v-else-if="plcy.execDt != null && plcy.cmplStat === 'F' && plcy.execYn === 'Y'"
                                        class="icon-tag" data-type="failer">{{ $t('POLICY.EVAL_STAT.FAIL_SOLVED') }}
                                        <!--실패(해결)--></span>
                                    <span
                                        v-else-if="plcy.execDt != null && plcy.cmplStat === 'F' && plcy.execYn === 'N'"
                                        class="icon-tag" data-type="failer">{{ $t('POLICY.EVAL_STAT.FAIL_UNSOLVED') }}
                                        <!--실패(미해결)--></span>
                                    <span v-else-if="plcy.execDt != null && plcy.cmplStat === 'E'"
                                          class="icon-tag" data-type="error">{{ $t('POLICY.EVAL_STAT.ERROR') }}
                                        <!--Error--></span>
                                    <span v-else-if="plcy.execDt != null && plcy.cmplStat === 'R'"
                                          class="icon-tag" data-icon="examining"
                                          data-type="waiting">{{ $t('POLICY.EVAL_STAT.EXAMINING') }}<!--검사중--></span>
                                    <span v-else-if="plcy.execDt == null"
                                          class="icon-tag" data-icon="unexamined"
                                          data-type="waiting">{{ $t('POLICY.EVAL_STAT.UNEXAMINED') }}
                                        <!--미검사--></span>
                                    <span class="seperate stand-alone"></span>
                                    <router-link v-if="plcy.execDt"
                                                class="buttons"
                                                data-icon-right="open"
                                                data-size="s" data-type="ghost" tag="button"
                                                v-bind:to="getExecLink(plcy)">
                                        <span class="open">{{ $t('POLICY.LABEL.GO_RESULT') }}</span></router-link>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    {{ $t('LABEL.CREATE') }}<!--생성-->
                                </th>
                                <td>
                                    <time datetime="">{{ convertUtcTimezoneToLocal(plcy.creaDt) }}</time>
                                    <span v-if="bUserSetting" class="seperate"></span>
                                    <span v-if="bUserSetting">{{ plcy.creaNm }}</span>
                                </td>
                            </tr>
                            <tr>
                                <th scope="row">
                                    {{ $t('LABEL.UPDATE') }}<!--업데이트-->
                                </th>
                                <td>
                                    <time datetime="">{{ convertUtcTimezoneToLocal(plcy.updtDt) }}</time>
                                    <span v-if="bUserSetting" class="seperate"></span>
                                    <span v-if="bUserSetting">{{ plcy.updtNm }}</span>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <!-- 적용된 규칙 -->
                    <RuleList
                        :key="getLocale"
                        :callDeleteRule="deleteGovernanceRule"
                        :callOpenPopup="openAddRulePopup"
                        :callOpenRuleDetail="openRuleDetail"
                        :callSetSearchKey="setSearchKey"
                        :callSetSortColumn="setSortColumn"
                        :categoryList="categoryList"
                        :cur-rule="detailRuleInfo"
                        :policy="plcy"
                        :ruleList="govRuleListByKey"
                        :templateList="templateList"
                        :menuAuth="getMenuAuth"
                        :originalRuleList="govRuleList"
                        :callImportRule="openImportRule"
                        :loadingRuleList="loadingRuleList"
                    />
                </div>
                <side-rule-detail
                    :actionTemplateList="actionTemplateList"
                    :callDeleteRule="deleteGovernanceRule"
                    :callHideDetail="closeRuleDetail"
                    :callOpenPopup="openAddRulePopup"
                    :categoryList="categoryList"
                    :policy="plcy"
                    :userList="userList"
                    v-bind:rule="detailRuleInfo"
                    :roleCode="roleCode"
                />
            </div>
        </article>
        <AddRuleModal
            ref="popUpModal"
            :callOnHide="onHideRuleModal"
            :callLoading="callLoading"
            :callSaveRule="insertGovernanceRule"
            :callSetActionList="setActionList"
            :actionTemplateList="actionTemplateList"
            :categoryList="categoryList"
            :newTmplt="newTmplt"
            :rule="rule"
            :userList="userList"
            :alertOptions="alertOptions"
            :roleCode="roleCode"
            :popUpTitle="popupTitle"
        />
        <Modal
            ref="plcySingleModal"
            :okFunction="handleModalOkFunc"
            :title="modal.popupTitle"
            :message="modal.popupMessage"
            :isShowPopup="modal.isShowPopup"
            :callOnHide="handleHideModal"
            :isOkDisabled="isModalOkDisabled"
            :btnOkStyle="modal.btnOkStyle"
            :modalClass="modal.popupType === 'addSchePopup' ? 'add-sche-popup' : ''"
            :okTitle="modal.okTitle">
            <template
                v-if="modal.popupType === 'addSchePopup'"
                v-slot:body-template>
                <AddingSchePopup
                    :callSetScheInfo="setScheInfo"
                    :vendors="tmpPlcy.vendorsjs"
                    :step="step"
                    :callGetStep="callGetStep"
                />
            </template>
        </Modal>
        <CustomModal
            :callOnHide="onHideCModal"
            :isShowPopup="cmodal.isShowPopup"
            :title="cmodal.popupTitle"
            :message="cmodal.popupMessage"
            :callAction2="()=>{refPlcy = []}"
            :callAction3="getRuleFromOtherPlcy"
            :isShowBtn1=false
            :btn2Txt="cmodal.btn2Txt"
            :btn3Txt="cmodal.btn3Txt"
            :disableBtn3="disableBtn3"
            btn2style="light"
            size="xl"
        >
            <template v-slot:body-template class="import-template">
                <ImportRuleForm
                    :currentCmpnId="curCmpnId"
                    @callSetSelectValue="getSlctRule"
                />
            </template>
        </CustomModal>
        <div-loading v-if="pending" :full="true"></div-loading>
    </main>
</template>
<script>
import ImportRuleForm from "./policyComponents/ImportRuleForm.vue"
import RuleList from "../rule/RuleList.vue";
import PolicySideRuleDetail from "./policySideRuleDetail.vue";
import {EventBus} from "../common/event-bus";
import AddRuleModal from "./policyComponents/AddRuleModal.vue";
import Modal from "../common/Modals/Modal.vue";
import AddingSchePopup from "../policy/policyComponents/AddingSchePopup.vue";
import CustomModal from "../common/Modals/CustomModal.vue"
import _ from "lodash";
import {mapGetters} from "vuex";

export default {
    name: 'PolicyDetail',
    components: {
        'side-rule-detail': PolicySideRuleDetail,
        RuleList,
        AddRuleModal,
        Modal,
        AddingSchePopup,
        CustomModal,
        ImportRuleForm
    },
    data() {
        return {
            popupTitle: "",
            isAddItem: false,
            tempRefPlcy: [],
            refPlcy: [],
            cmodal: {
                isShowPopup: false,
            },
            selectedPlcyScheInfo: {
                doCmpl: true,
            },
            modal: {
                isShowPopup: false,
            },
            delRuleList: [],
            message: '메시지',
            isEdit: false, // Rule Popup 등록, 수정 상태 체크
            isCopy: false, // Rule Popup 등록, 수정 상태 체크
            doRefresh: false, // rule list refresh 값
            plcy: {},
            originPlcy: {},
            categoryList: [],
            actionTemplateList: [], // Action Template List
            userList: [], // User List for Action
            detailRuleInfo: {},
            rule: {}, // popup 에 보내줄 rule 데이터
            newTmplt: [], //
            invalidPolicyTitle: false, // Policy Title 유효성 검사
            duplicatedPolicyTitle: false, // Policy Title 중복 검사
            fEdit: {
                titl: false,
                desc: false
            },
            pending: false,
            govRuleList: [],
            govRuleListByKey: [],
            policyDetail: {},
            searchSvrty: this.constants.PARAM.SELECT.SEARCH_SEVERITY,                     // SearchList of Severity : 처음 전체선택으로 모든 값 넣어줌
            sortColumn: '',                                // Sort column
            sortOrder: '',                                 // Sort order
            ruleListSearchKey: {},
            okFuncFlag: false,
            step: 1,
            callOkFuncFlag: false,
            tempRules:[],
            disableBtn3: true,
            isLoading: false,
            alertOptions: [],
            roleCode: null,
            loadingRuleList: false,
        }
    },
    created() {
        this.pending = true;
        this.selectCategoryList();
        this.selectActionTemplateList();
        this.selectUserList();
        this.selectGovernanceRuleList();
        
        EventBus.$on("emit-copy-rule", ruleId => {
            this.openCopyRulePopup(ruleId)
        });
        this.slctPlcy();
    },
    mounted: function () {
        this.setManagementOptions();
        this.getAlertCreatePermission();
    },
    computed: {
        ...mapGetters({
            curCmpnId: 'user/curCmpnId',
            policyHistory: 'user/policyHistory',
            siteCd: 'user/siteCd',
            loginUser: 'user/loginUser'
        }),
        getMenuAuth: function () {
            //메뉴 별 권한
            let auth = _.find(this.$store.state.GOV_MENU_AUTH, {menuId: this.constants.MENU.POLICY})
            return auth ? auth.authTypeCd : this.constants.AUTH_TYPE.NONE
        },
        templateList: function () {
            return this.$store.state.templateList;
        },
        // url 에 /replica 가 있으면 Policy 복사로 들어온 것
        bUserSetting: function () {
            return this.plcy.userDefiYn === 'Y'
        },
        rvsnId: {
            get: function () {
                return this.$route.query.rvsn;
            },
            set: function (value) {
                return this.$route.query.rvsn = value;
            }
        },
        getLocale: function () {
            return this.$i18n.locale
        },
        isModalOkDisabled() {
            if (this.modal.popupType === 'addSchePopup') {
                let stepDisabled = this.getStepDisabled();
                return stepDisabled == this.step;
            }
        },
    },
    watch: {
        curCmpnId: function () {
            this.$router.push(`/policy`);
        },
        doRefresh() {
            this.slctPlcy();
            this.selectGovernanceRuleList();
        },
        "plcy.cmplStat"(newVal) {
            if (newVal !== "R") {
                this.cancelAutoUpdate();
            }
        }
    },
    methods: {
        onHideRuleModal() {
            // this.alertOptions = [];
        },
        async getAlertCreatePermission() {
            const {ADMIN, SERVICE_MANAGER} = this.constants.ROLE_CODE;
            const url = `/api/external/${this.curCmpnId}/${this.loginUser.userId}/role`;
            const response = await this.http.get(url);
            
            const roleCode = _.get(response, "data.data.roleCode");
            if (roleCode === ADMIN) {
                this.alertOptions.push({key: 'NEW', value: 'Create New'});
            }
            if (roleCode === ADMIN || roleCode === SERVICE_MANAGER) {
                await this.getAlertAction();
            }
            this.roleCode = roleCode;
        },
        async getAlertAction() {
            const url = `/api/external/${this.curCmpnId}/${this.loginUser.userId}`;
            const response = await this.http.get(url);
            const options = _.get(response, "data.data");
            if (options) {
                options.forEach(opt => {
                    opt.key = opt.unqKey,
                    opt.value = opt.dispNm
                })
            }            
            this.alertOptions = this.alertOptions.concat(options);
        },
        getExecLink(plcy) {
            if (plcy.rsltId) {
                return `/compliance/detail?cmpl=${plcy.cmplId}&rslt=${plcy.rsltId}`;
            }
            return `/compliance/detail?cmpl=${plcy.cmplId}`;
        },
        reformatRule(raw) {
            const rule = raw;
            rule.cndVal = JSON.parse(raw.cndVal);
            rule.ctgLabel = JSON.parse(raw.ctgLabel);
            rule.actnVal = JSON.parse(raw.actnVal);
            return rule;
        },
        async getRuleFromOtherPlcy() {
            this.pending = true;
            this.refPlcy = this.tempRefPlcy.map(policy => policy.rvsnId);
            let tempRules = this.tempRules;
            let rules = [];
            (tempRules || []).forEach(rule => {
                rules.push({
                    ruleId: rule.ruleId,
                    titl: rule.transTitl,
                    desc: rule.transDesc,
                    remd: rule.transRemd,
                    rulePlcyRvsnId: rule.rulePlcyRvsnId
                });
            });
            const url = "/api/governance/rule/import";
            const header = {
                siteCd: this.siteCd,
                cmpnId: this.curCmpnId,
                plcyRvsnIds: this.refPlcy,
                plcyId: this.plcy.plcyId,
                rvsnId: this.rvsnId,
                rvsn: this.plcy.rvsn,
                rules: rules,
                lang: (this.getLocale || 'en'),
                titl: this.plcy.userDefiYn === this.constants.PARAM.SELECT.N ? this.plcy[this.$i18n.locale+'Title'] : this.plcy.titl,
                desc: this.plcy.userDefiYn === this.constants.PARAM.SELECT.N ? this.plcy[this.$i18n.locale + 'Desc'] : this.plcy.desc
            };
            try {
                const response  = await this.http.post(url, JSON.stringify(header));
                if (response.data.status != 'fail') {
                    const url = "/policy/detail";
                    const rvsnId = response.data.result.rvsnId;
                    this.$router.push({path: url, query: {rvsn: rvsnId}});
                    await this.selectGovernanceRuleList();
                }
            } catch (err) {
                console.error('getRuleFromOtherPlcy: ' + err);
            } finally {
                this.pending = false;
            }
            
        },
        getSlctRule(evnt) {
            this.tempRefPlcy = evnt.policys;
            this.tempRules = evnt.rules;
            if (this.tempRefPlcy.length != 0 || this.tempRules.length != 0) {
                this.disableBtn3 = false;
            } else {
                this.disableBtn3 = true;
            }
        },
        onHideCModal() {
            this.disableBtn3 = true;
            this.cmodal = {
                isShowPopup: false
            }
        },
        openImportRule() {
            this.cmodal = {
                isShowPopup: true,
                popupTitle: this.$t('COMMON.POPUP.TITLE.IMPORT_RULE'),
                popupMessage: this.$t('COMMON.POPUP.DESC.IMPORT_RULE'),
                btn2Txt: this.$t('COMMON.BUTTON.CAMEL.CANCEL'),
                btn3Txt: this.$t('COMMON.BUTTON.UPPER.OK')
            }  
        },
        
        editTransInfo(rule) {
            const eRule = rule;
            const localeSupport = ['en', 'ko', 'zh', 'jp'];
            localeSupport.forEach((locale)=>{
                if (locale != this.getLocale) {
                    eRule[`${locale}RuleDesc`] = "";
                    eRule[`${locale}RuleRemd`] = "";
                    eRule[`${locale}RuleTitle`] = "";
                } else {
                    eRule[`${locale}RuleDesc`] = rule.transDesc;
                    eRule[`${locale}RuleRemd`] = rule.transRemd;
                    eRule[`${locale}RuleTitle`] = rule.transTitl;
                }
            });
            eRule.titl = rule.transTitl;
            return eRule;
        },
        async deleteRule() {
            // 복제 상태가 아닌경우 바로 delete
            const url = '/api/governance/rule/delete';
            const cloneRuleList = _.cloneDeep(this.delRuleList);
            // 표시 위해 List로 바꾼걸 다시 String으로 바꿈. 삭제 시 API 쪽에서 Type Error 발생함(공통 로직 사용으로 여기서 변경해서 보내줌..)
            for (let rule of cloneRuleList) {
                rule.cndVal = JSON.stringify(rule.cndVal)
                rule.actnVal = JSON.stringify(rule.actnVal)
                rule.ctgLabel = JSON.stringify(rule.ctgLabel)
            }
            const ruleData = {
                cmpnId: this.loginUser.curCmpnId,
                plcyId: this.plcy.plcyId,
                plcyRvsnId: this.rvsnId,
                ruleList: cloneRuleList
            };
            try {
                this.loadingRuleList = true;
                const response = await(this.http.post(url, ruleData));
                // eunhye check
                EventBus.$emit('toastComment', 'POLICY.TOAST.DELETED_RULE');
                if (response.data.status === 'ok') {
                    this.closeRuleDetail();
                    this.afterSaveRule(response.data.result.plcyRvsnId);
                } else {
                    const msg = _.get(response, "data.error.message", 500);
                    console.error('DELETED_RULE: ', msg);
                }
            } catch (err) {
                console.error('DELETED_RULE: ', err);
            } finally {
                this.loadingRuleList = false;
            }
        },
        setScheInfo(scheInfo) {
            this.selectedPlcyScheInfo = {...this.selectedPlcyScheInfo, ...scheInfo};
        },
        openAddSchePopup(policy) {
            if (typeof policy.vendorsjs == 'string') {
                policy.vendorsjs = JSON.parse(policy.vendorsjs) || [];
            }
            if (policy.vendorsjs == null || policy.vendorsjs.length == 0) {
                policy.vendorsjs = [];
                this.okFuncFlag = true;
                this.okTitle = this.$t('COMMON.BUTTON.CAMEL.OK');
            }
            this.tmpPlcy = policy;
            this.modal = {
                popupTitle: this.$t('POLICY.ADD_POPUP.POPUP_TITLE'),
                popupMessage: '',
                isShowPopup: true,
                okTitle: this.$t('COMMON.BUTTON.CAMEL.NEXT'),
                popupType: 'addSchePopup'
            }
        },
        handleHideModal() {
            if (this.modal.popupType === 'addSchePopup') {
                if (this.callOkFuncFlag) {
                    if (this.okFuncFlag) {
                        this.modal.okTitle = this.$t('COMMON.BUTTON.CAMEL.NEXT');
                        this.setScheInfo({doCmpl: true});
                        this.modal.isShowPopup = false;
                        this.okFuncFlag = false;
                        this.step = 1;
                    }
                    this.callOkFuncFlag = false;
                    return;
                }
                this.modal.okTitle = this.$t('COMMON.BUTTON.CAMEL.NEXT');
                this.setScheInfo({doCmpl: true});
                this.modal.isShowPopup = false;
                this.okFuncFlag = false;
                this.step = 1;
            } else {
                this.modal.isShowPopup = false;
            }
            
        },
        openDeleteModal() {
            let deleteMessage = this.$t('POLICY.DEL_POPUP.DESC');
            if (this.plcy.cmplStat === "R") {
                deleteMessage = this.$t('POLICY.DEL_POPUP.DESC_BEING_EVALUATED');
            } else if (this.plcy.cmplId !== null) {
                deleteMessage = this.$t('POLICY.DEL_POPUP.DESC_INCLUDED_COMPLIANCE');
            }
            this.modal = {
                popupTitle: this.$t('POLICY.LABEL.DEL_POLICY'),
                popupMessage: deleteMessage,
                okTitle: this.$t('COMMON.BUTTON.CAMEL.DELETE'),
                isShowPopup: true,
                popupType: 'delPlcy',
                btnOkStyle: 'danger'
            }
        },
        setSortColumn(sortColumn) {
            const sortObject = this.Common.setSortColumn(this.sortColumn, this.sortOrder, sortColumn);
            this.sortColumn = sortObject.sortColumn;
            this.sortOrder = sortObject.sortOrder;
            this.getRuleByKey();
        },
        setSearchKey(key, value) {
            this.ruleListSearchKey = {
                ...this.ruleListSearchKey,
                [key]: value
            };
            this.getRuleByKey();
        },
        getRuleByKey() {
            const {searchTxt, searchCtg, searchProd} = this.ruleListSearchKey;
            let self = this;
            let filtered = _.cloneDeep(this.govRuleList);
            filtered = _.forEach(filtered, function (o) {
                _.forEach(o.cndVal, function (k) {
                    let ruleProd = _.find(self.templateList, {'tmpltId': k.tmpltId})
                    if (typeof (ruleProd) !== 'undefined') {
                        o.prodNm = ruleProd.prod
                    }
                })
            })
            // Text filter
            if (!this.Common.isEmptyText(searchTxt)) {
                filtered = this.govRuleList.filter((item) => {
                    const ruleName = item[`${this.getLocale}RuleTitle`];
                    if (ruleName) {
                        return ruleName.toLowerCase().includes(searchTxt.toLowerCase());
                    } else {
                        return item.titl.toLowerCase().includes(searchTxt.toLowerCase());
                    }
                })
            }
            // Category filter
            if (typeof (searchCtg) !== 'undefined' && searchCtg.length > 0) {
                filtered = _.filter(filtered, function (o) {
                    for (let srchCtg of searchCtg) {
                        if (_.includes(o.ctgLabel, srchCtg)) {
                            return true;
                        }
                    }
                    return false;
                })
            }
            // Product filter
            if (typeof (searchProd) !== 'undefined' && searchProd.length > 0) {
                let manualRules = [];
                if (searchProd.includes('manual')) {
                    manualRules = _.cloneDeep(_.filter(filtered, {'autoExeYn': 'N'}));
                }
                filtered = _.filter(filtered, function (o) {
                    let fill = _.filter(o.cndVal, function (k) {
                        let ruleProd = _.find(self.templateList, {'tmpltId': k.tmpltId})
                        for (let srchProd of searchProd) {
                            if (ruleProd && ruleProd.prod === srchProd) {
                                return true;;
                            }
                        }
                        return false;
                    })
                    return fill.length > 0;
                })
                filtered = filtered.concat(manualRules);
            }
            if (this.searchSvrty.length !== this.constants.SVRTY_FILTER.length) {
                filtered = filtered.filter((p) => {
                    return _.includes(this.searchSvrty, p.svrty)
                })
            }
            // Sorting 처리
            if (this.sortColumn !== '' && this.sortOrder !== '') {
                filtered = _.orderBy(filtered, [this.sortColumn], [self.sortOrder])
            }
            this.govRuleListByKey = filtered;
        },
        getRuleListOnlyReplica() {
            let list = _.cloneDeep(this.govRuleListByKey);
            const locale = this.getLocale;
            for (let rule of list) {
                const userDefined = rule.userDefiYn === this.constants.PARAM.SELECT.N;
                rule.titl = userDefined ? rule[`${locale}RuleTitle`] : rule.titl;
                rule.desc = userDefined ? rule[`${locale}RuleDesc`] : rule.desc;
                rule.remd = userDefined ? rule[`${locale}RuleRemd`] : rule.remd;
                rule.cmpnId = this.curCmpnId;
                rule.cndVal = JSON.stringify(rule.cndVal)
                rule.actnVal = JSON.stringify(rule.actnVal)
                rule.ctgLabel = JSON.stringify(rule.ctgLabel)
            }
            return list
        },
        async selectGovernanceRuleList() {
            const url = '/api/governance/rule/list';
            const ruleData = {
                cmpnId: this.curCmpnId,
                rvsnId: this.rvsnId
            }
            const result  = await(this.http.post(url, ruleData));
            if (result && result.data.status === 'ok') {
                // for 에서 text 를 json 으로 parse
                for (let rule of result.data.result) {
                    rule.transTitl = rule.userDefiYn === this.constants.PARAM.SELECT.N ? this.rule[this.getLocale + 'RuleTitle'] : rule.titl;
                    rule.transDesc = rule.userDefiYn === this.constants.PARAM.SELECT.N ? this.rule[this.getLocale + 'RuleDesc'] : rule.desc;
                    rule.transRemd = rule.userDefiYn === this.constants.PARAM.SELECT.N ? this.rule[this.getLocale + 'RuleRemd'] : rule.remd;
                    rule.cndVal = this.Common.parseJSON(rule.cndVal);
                    rule.actnVal = this.Common.parseJSON(rule.actnVal)
                    rule.ctgLabel = this.Common.parseJSON(rule.ctgLabel)
                }
                this.govRuleList = result.data.result;
                this.getRuleByKey();
            }
        },
        callLoading(isLoading) {
            this.pending = isLoading;
        },
        async slctPlcy() {
            const url = "/api/governance/policy/policy";
            const header = {
                cmpnId: this.curCmpnId,
                rvsnId: this.rvsnId
            };
            try {
                const result = await(this.http.post(url, JSON.stringify(header)));
                const plcy = _.get(result, "data.result", null);
                if (plcy) {
                    plcy.transTitl = plcy.userDefiYn === this.constants.PARAM.SELECT.N ? plcy[this.getLocale + 'Title'] : plcy.titl;
                    this.plcy = plcy;
                    if (this.isAddItem) {
                        this.plcy.execDt = Date.now();
                        this.plcy.cmplStat = 'R';
                        this.isAddItem = false;
                    }
                    this.originPlcy = _.cloneDeep(plcy);
                }
            } catch (error) {
                console.error("policyDetail error: ", error);
            } finally {
                this.pending = false;
            }
        },
        // Policy Title, Description 수정
        async updtPlcy(item) {
            if (this.isInvalidPolicyTitle()) return;
            const plcyData = {
                cmpnId: this.curCmpnId,
                plcyId: this.plcy.plcyId,
                rvsnId: this.rvsnId,
                desc: this.plcy.desc
            };
            if (item === 'titl') {
                plcyData.titl = this.plcy.titl;
            }
            const url = "/api/governance/policy";
            try {
                EventBus.$emit('toastComment', 'POLICY.TOAST.EDITED_RULE');
                const result = await(this.http.put(url, plcyData));
                if (result.data.status === 'ok') {
                    this.changeEditStatus(item, false);
                    this.originPlcy = _.cloneDeep(this.plcy);
                    this.$router.replace(`/policy/detail?rvsn=${result.data.result.rvsnId}`);
                } else if (result.data.status === 'fail' && result.data.error.message === 'ERROR_D') {
                    // 타이틀 중복 처리
                    this.duplicatedPolicyTitle = true;
                }
            } catch (error) {
                console.error("updtPlcy: ", error);
            }
        },
        cancelUpdtPlcy(item) {
            this.changeEditStatus(item, false);
            this.plcy = _.cloneDeep(this.originPlcy);
        },
        // Category 목록 조회. Popup, Detail 둘 다 사용하기때문에 여기서 조회
        selectCategoryList() {
            var url = `/api/governance/category/list/simple`;
            var body = {
                "cmpnId": this.curCmpnId
            };

            this.http.post(url, body)
                .then(response => {
                    this.categoryList = response.data.result;
                });
        },
        // Action 목록 조회
        async selectActionTemplateList() {
            // Action List 초기화
            this.actionTemplateList = [];

            const url = "/api/governance/actn";
            const response = await(this.http.get(url));
            this.actionTemplateList = response.data.result;
        },
        // Action Email 에서 사용할 사용자 List 가져오기
        async selectUserList() {
            const url = '/api/governance/user/list';
            const header = {
                'cmpnId': this.loginUser.curCmpnId
            };
            const response = await(this.http.post(url, header));
            this.userList = _.get(response, "data.result", []);
        },
        convertUtcTimezoneToLocal: function (date) {
            return date == null ? '-' : this.Common.convertUtcTimezoneToLocalByLang(date, this.getLocale)
        },
        setActionList(selectedTemplateList) {
            let actionListBySelectedTemplate = (_.filter(this.actionTemplateList, {'prod': 'default'}));
            _.forEach(_.groupBy(selectedTemplateList, 'prod'), function (value, key) {
                actionListBySelectedTemplate = actionListBySelectedTemplate.concat(_.filter(self.actionTemplateList, {'prod': key}));
            });
        },
        // Open side rule view
        openRuleDetail: function (rule) {
            this.detailRuleInfo = rule
            typeof ($('.layout-contents').attr('data-side-expand')) === 'undefined' ? $('.layout-contents').toggleAttr('data-side-expand', '') : false
        },
        // Close side rule view
        closeRuleDetail: function () {
            this.detailRuleInfo = {}
            $('.layout-contents').removeAttr('data-side-expand')
        },
        addRule(rule) {
            const eRule = this.editTransInfo(rule);
            this.govRuleListByKey.push(eRule);
            this.govRuleList = this.govRuleListByKey;
        },
        // isEdit 로 구분해서 Insert, Update 함
        async insertGovernanceRule(rule) {
            const url = "/api/governance/rule";
            // Policy 복제일 때
            // string 으로 변경하기 전 newObj 복사. 화면에서 string 으로 바꼈다고 에러 폭발함
            let tempObj = _.cloneDeep(rule)

            tempObj.cmpnId = this.curCmpnId
            tempObj.plcyId = this.plcy.plcyId
            tempObj.plcyRvsnId = this.rvsnId

            tempObj.cndVal = JSON.stringify(tempObj.cndVal)
            tempObj.actnVal = JSON.stringify(tempObj.actnVal)
            tempObj.ctgLabel = JSON.stringify(tempObj.ctgLabel)

            const header = tempObj;

            if (this.isEdit) {
                try {
                    const response = await(this.http.put(url, header));
                    this.afterSaveRule(response.data.result.plcyRvsnId);
                    this.pending = false;
                    // 기본 policy에서 rule 수정
                    EventBus.$emit('toastComment', 'POLICY.TOAST.EDITED_RULE');
                } catch (err) {
                    console.error('EDITED_RULE: ', err);
                } finally {
                    this.pending = false;
                }
            } else {
                try {
                    const response = await(this.http.post(url, JSON.stringify(header)));
                    this.afterSaveRule(response.data.result.plcyRvsnId);
                    if (typeof (this.isEdit) === 'undefined') {
                        // case4. 기본 policy에서 rule 복사
                        EventBus.$emit('toastComment', 'POLICY.TOAST.COPIED_RULE')
                    } else {
                        // case5. 기본 policy에서 rule 추가
                        EventBus.$emit('toastComment', 'POLICY.TOAST.ADDED_RULE')
                    }
                } catch (err) {
                    console.error('Insert Rule: ', err);
                } finally {
                    this.pending = false;
                }
            }
        },
        deleteGovernanceRule(delRuleList) {
            this.delRuleList = delRuleList;
            this.modal = {
                popupTitle: this.$t('POLICY.RULE.POPUP.TITLE.DELETE'),
                popupMessage: this.$t('POLICY.RULE.POPUP.DESC.DELETE'),
                okTitle: this.$t('COMMON.BUTTON.CAMEL.DELETE'),
                isShowPopup: true,
                popupType: 'delRule',
                btnOkStyle: 'danger'
            }
        },
        // Rule 기본되는 값
        getDefaultRuleObject() {
            return {
                titl: '',
                actnExeYn: 'Y',
                ctgLabel: [],
                cndVal: [{
                    tmpltId: 'new',
                    cjt: null
                }],
                svrty: 1,
                actnVal: [{
                    actnId: null
                }],
            };
        },
        goBack() {
            this.$router.go(-1);
        },
        replicatePolicy() {
            const url = "/policy/replica"
            this.$router.push({path: url, query: {rvsn: this.rvsnId}});
        },
        handleModalOkFunc(bvModalEvt) {
            if (this.modal.popupType === 'addSchePopup') {
                this.callOkFuncFlag = true;
                if (this.okFuncFlag) {
                    this.addPolicyToCompliance();
                } else {
                    bvModalEvt.preventDefault();
                    this.step++;
                }
            } else {
                this.handleActionModal();
            }
        },
        handleActionModal() {
            const {cmpnId, plcyId, rvsnId} = this.plcy;
            const header = {
                cmpnId,
                plcyId,
                rvsnId
            };
            try {
                if (this.modal.popupType === "delPlcy") {
                    const url = "/api/governance/policy/delete";
                    this.http.post(url, JSON.stringify(header))
                } else if (this.modal.popupType === "delRule") {
                    this.deleteRule();
                }
            } catch (err) {
                console.error("handleActionModal: ", err);
            } finally {
                this.$router.push('/policy');
            }
            
        },
        goToHistory(plcy) {
            const url = "/audit/detail";
            this.$router.push({path: url, query: {plcy: plcy.plcyId}});
        },
        afterSaveRule(newPlcyRvsnId) {
            // newPlcyRvsnId : 새 Policy Revision ID
            $.magnificPopup.close()
            this.doRefresh = !this.doRefresh
            const url = '/policy/detail';
            this.$router.push({path: url, query: {rvsn: newPlcyRvsnId}});
        },
        openCopyRulePopup: function (ruleId) {
            this.openPopup(data)
        },
        // 유효성 검사
        isInvalidPolicyTitle() {
            this.duplicatedPolicyTitle = false
            this.invalidPolicyTitle = !!this.Common.isEmptyText(this.plcy.titl);
            return this.invalidPolicyTitle
        },
        openAddRulePopup(rule, FORM_TYPE) {
            this.isEdit = false;
            this.isCopy = false;
            if (FORM_TYPE === this.constants.FORM_TYPE.EDIT) {
                this.isEdit = true;
                this.popupTitle = "Edit Rule";
            } else if (FORM_TYPE === this.constants.FORM_TYPE.COPY) {
                this.isCopy = true;
                this.popupTitle = "Copy Rule";
            }
            this.newTmplt = [];
            if (rule != null) {
                this.rule = _.cloneDeep(rule);
                // 다국어 정의되고 바꾼다...
                const copiedTitle = this.$t('POLICY.RULE.COPY_TITLE', {'ruleName': this.rule.titl});
                this.rule.titl = this.isCopy ? copiedTitle : this.rule.titl;
                for (var cnd of this.rule.cndVal) {
                    // newTemplate 에 맞는 Template ID 넣어주기
                    for (var tmplt of this.templateList) {
                        if (cnd.tmpltId === tmplt.tmpltId) {
                            this.newTmplt.push(tmplt);
                        }
                    }
                }
            } else {
                this.rule = this.getDefaultRuleObject();
            }
            // // 수정의 경우 먼저 선택한 Action List 세팅
            this.setActionList(this.newTmplt);
            this.$refs['popUpModal'].showPopup(FORM_TYPE);
        },
        async addPolicyToCompliance() {
            console.log("addPolicyToCompliance");
            if (this.pending) return;
            this.pending = true;
            this.isAddItem = true;
            const event = this.selectedPlcyScheInfo;
            const cmpnId = this.curCmpnId;
            const {plcyId, cmplId} = this.plcy;
            const data = {
                cmpnId,
                cmplId,
                plcyId,
                rvsnId: this.rvsnId,
                doCmpl: event.doCmpl,
                accounts: event.accounts || [],
                regions: event.regions || []
            };
            if (event.execType === 'A') {
                data.execType = event.execType;
                data.scheInfo = event;
                data.scheInfo.cmpnId = cmpnId;
                data.scheInfo.cmplId = cmplId;
            }
            const url = "/api/governance/policy/apply";
            const response  = await this.http.post(url, data);
            if (response.data.status === 'ok') {
                EventBus.$emit('addPolicyToCompliance');
            }
            this.timer = setInterval(this.slctPlcy, 3000);
        },
        setManagementOptions: function () {
            var $moreActions = $('[data-trigger="management"]')
            $moreActions.tooltipster({
                animation: 'fade',
                side: 'bottom',
                theme: 'go-actions',
                interactive: true,
                trigger: 'click',
                arrow: false,
                functionBefore: function (instance, helper) {
                    $(helper.origin).addClass("selected")
                },
                functionAfter: function (instance, helper) {
                    $(helper.origin).removeClass("selected")
                },
                functionPosition: function (instance, helper, position) {
                    position.coord.top -= 7
                    position.coord.left = helper.geo.origin.offset.right - position.size.width
                    return position;
                }
            });
        },
        changeEditStatus(item, status) {
            this.fEdit[item] = status
        },
        callGetStep(step) {
            this.step = step;
            if (step == 3) {
                this.okFuncFlag = true;
                this.modal.okTitle = this.$t('COMMON.BUTTON.CAMEL.OK');
            } else {
                this.okFuncFlag = false;
                this.modal.okTitle = this.$t('COMMON.BUTTON.CAMEL.NEXT');
            }
        },
        cancelAutoUpdate() {
            clearInterval(this.timer);
        },
        getStepDisabled() {
            let stepDisabled = null;
            if (this.step == 2) {
                let accounts = this.selectedPlcyScheInfo['accounts'] || [];
                if (accounts.length === 0) {
                    stepDisabled = 2;
                }
            }
            if (this.step == 3) {
                let regions = this.selectedPlcyScheInfo['regions'] || [];
                if (regions.length === 0) {
                    stepDisabled = 3;
                }
            }
            return stepDisabled;
        }
    },
    beforeDestroy() {
        this.cancelAutoUpdate();
    }
}
</script>

<style lang="scss" scoped>
.layout-contents-container .layout-contents[data-side-expand] .left-view {
    width: 100%;
}

.layout-contents-container .layout-contents[data-side-expand] .right-view {
    position: absolute;
    right: 0;
    box-shadow: -5px 16px 8px #888888;
    width: 80%;
    max-width: 80%;
    z-index: 10;
}
</style>
<style>
.add-sche-popup .modal-body {
    padding: 0 !important;
    margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/policy/policyDetail.vue